'use client'

import { useEffect } from 'react'

// Records one counted story view after the page has shown (free and paid
// tiers, 2026-10-19). Mounted only when the server decided this view counts
// (services/access/reader-access storyAccess): from the newsletter or while
// browsing, not the page a reader landed on. After render, not during it,
// so a prefetch never spends a reader's allowance.
export default function StoryViewBeacon({ slug }) {
  useEffect(() => {
    fetch('/api/story-view', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ slug }),
      keepalive: true,
    }).catch(() => {})
  }, [slug])
  return null
}
